export default __webpack_public_path__ + "static/media/noun-heart-135904-DFD4D5.291f418a.png";